import { Injectable } from '@angular/core';
import {StoryService} from "../story/story.service";
import {ProfessionsService} from "./professions.service";
import {ProvidersService} from "./providers.service";
import {JobService} from "./job.service";

@Injectable({
  providedIn: 'root'
})
export class UrlHashService {

  constructor(private storyService: StoryService,
              private professionsService: ProfessionsService,
              private providersService: ProvidersService,
              private jobsService: JobService) { }

  tryOpen() {
    let currentHash = window.location.hash;
    if(currentHash && currentHash.length) {
      currentHash = currentHash.slice(1);
      try {
        const decodedHash = atob(currentHash);

        if(decodedHash.indexOf("story-") !== -1) {
          this.storyService.activateStoryFromUrl();
        } else if(decodedHash.indexOf(this.professionsService.PROFESSIONS_HASH_FILTER_PREFIX) !== -1) {
          this.professionsService.setFiltersFromUrl();
        } else if(decodedHash.indexOf(this.providersService.PROVIDERS_HASH_FILTER_PREFIX) !== -1) {
          this.providersService.setFiltersFromUrl();
        } else if(decodedHash.indexOf(this.jobsService.JOBS_HASH_FILTER_PREFIX) !== -1) {
          this.jobsService.setFiltersFromUrl();
        }
      } catch (e) {
        return;
      }
    }
  }

  updateHash(hash: string) {
    if(hash.length) hash = "#" + hash;
    window.history.pushState({}, "", window.location.origin + window.location.pathname + hash);
  }
}
